(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["allfill-calculator"] && !Shopify.designMode) return;
  try {
    
function createFillEngine() {
  'use strict';
  const fills = {
    beads: {name:'Bean bag beads', ft3PerLb:1 / 0.49, unit:'ft³', normal:10, soft:false},
    buckwheat: {name:'Buckwheat hulls', ft3PerLb:0.09, unit:'lb', normal:20, soft:false},
    kapok: {name:'Kapok fiber', ft3PerLb:0.45, unit:'lb', normal:20, soft:true},
    hemp_fiber: {name:'Hemp fiber', ft3PerLb:0.45, unit:'lb', normal:25, soft:true},
    latex: {name:'Shredded latex', ft3PerLb:0.29, unit:'lb', normal:20, soft:true},
    foam: {name:'Shredded foam', ft3PerLb:0.60, unit:'lb', normal:20, soft:true}
  };
  // Retained for future use only. Millet is unavailable and is not selectable.
  const unavailableDensities = {millet:0.14};
  const lengthUnits = {in:1 / 12, ft:1, cm:1 / 30.48, m:1 / 0.3048};
  const volumeUnits = {ft3:1, l:1 / 28.316846592, m3:1 / 0.028316846592, gal:1 / 7.48051948051948};
  const shapes = {
    sphere: {name:'Sphere / round bean bag', fields:[['d','Diameter']], volume:v=>Math.PI * v.d ** 3 / 6},
    box: {name:'Rectangular cushion / box', fields:[['l','Length'],['w','Width'],['h','Thickness / height']], volume:v=>v.l * v.w * v.h},
    cylinder: {name:'Round cushion / cylinder', fields:[['d','Diameter'],['h','Thickness / height']], volume:v=>Math.PI * v.d ** 2 * v.h / 4},
    cube: {name:'Cube', fields:[['a','Side length']], volume:v=>v.a ** 3},
    tri_prism: {name:'Wedge / triangular prism', fields:[['b','Triangle base'],['h','Triangle height'],['l','Length']], volume:v=>v.b * v.h * v.l / 2}
  };
  const positive = n => typeof n === 'number' && Number.isFinite(n) && n > 0;
  function shapeVolume(shape, values) {
    const config = shapes[shape];
    if (!config || !config.fields.every(([key])=>positive(values[key]))) return null;
    const volume = config.volume(values);
    return positive(volume) ? volume : null;
  }
  function preset(fill, use) {
    if (!fills[fill]) return null;
    if (use === 'beanbag') return 40;
    if (use === 'seating') return fills[fill].soft ? 200 : 100;
    if (use === 'body' || use === 'head') {
      if (fill === 'buckwheat') return use === 'head' ? 80 : 85;
      if (fill === 'latex' || fill === 'foam') return 200;
    }
    return 100;
  }
  function estimate(volume, fill, percent, job) {
    const material = fills[fill];
    if (!material || !positive(volume) || !Number.isFinite(percent) || percent < 10 || percent > 300 || !['full','refluff','topup'].includes(job)) return null;
    const fullVolume = volume * percent / 100;
    const ratios = job === 'topup' ? [0.25,0.30] : job === 'refluff' ? [0.5,0.5] : [1,1];
    const fullWeight = fullVolume / material.ft3PerLb;
    const fullQuantity = fill === 'beads' ? fullVolume : fullWeight;
    const result = {volume, fullVolume, fullWeight, low:fullQuantity * ratios[0], high:fullQuantity * ratios[1], orderVolume:fullVolume * ratios[1], orderWeight:fullWeight * ratios[1], unit:material.unit};
    return Object.values(result).filter(v=>typeof v === 'number').every(Number.isFinite) ? result : null;
  }
  function parsePack(options, fill) {
    const re = fill === 'beads' ? /^(\d+(?:\.\d+)?)\s*(?:cubic\s*(?:ft|feet)|cu\.?\s*ft\.?|ft³|ft3)\.?$/i : /^(\d+(?:\.\d+)?)\s*(?:lb|lbs|pound|pounds)\.?$/i;
    const matches = options.map(x=>String(x).trim().match(re)).filter(Boolean);
    if (matches.length !== 1) return null;
    const size = Number(matches[0][1]);
    // Retail sizes from the supplied product export; never infer size from shipping weight or SKU digits.
    const allowed = fill === 'beads' ? [2,4,8,10] : fill === 'hemp_fiber' ? [1,5,10,25] : [1,2.5,5,10,20];
    return allowed.includes(size) ? size : null;
  }
  // Bounded, half-unit dynamic programming: least excess first, then item price, then package count.
  // All amounts use unrounded calculations. Stock and quantity rules constrain eligible combinations.
  function packages(need, variants) {
    if (!positive(need) || need > 500) return null;
    const eligible = variants.filter(v=>positive(v.size) && Number.isFinite(v.price) && v.price >= 0 && v.available && v.max >= v.min && v.min >= 1 && v.increment >= 1);
    if (!eligible.length) return null;
    const target = Math.ceil(need * 2 - 1e-9);
    const ceiling = Math.min(4000,target + Math.max(...eligible.map(v=>Math.round(v.size * 2) * (v.min + v.increment - 1))) - 1);
    let dp = Array(ceiling + 1).fill(null);
    dp[0] = {cost:0,count:0,items:[]};
    for (const variant of eligible) {
      const next = dp.slice();
      const units = Math.round(variant.size * 2);
      const max = Math.min(variant.max,Math.floor(ceiling / units));
      for (let sum=0;sum<dp.length;sum++) {
        if (!dp[sum]) continue;
        for (let q=variant.min;q<=max;q+=variant.increment) {
          const total = sum + units * q;
          if (total > ceiling) break;
          const candidate = {cost:dp[sum].cost + q * variant.price,count:dp[sum].count + q,items:[...dp[sum].items,{...variant,quantity:q}]};
          const old = next[total];
          if (!old || candidate.cost < old.cost || (candidate.cost === old.cost && candidate.count < old.count)) next[total] = candidate;
        }
      }
      dp = next;
    }
    for (let sum=target;sum<dp.length;sum++) if (dp[sum]) return {...dp[sum],total:sum / 2};
    return null;
  }
  return {fills,unavailableDensities,lengthUnits,volumeUnits,shapes,positive,shapeVolume,preset,estimate,parsePack,packages};
}

(() => {
  'use strict';
  if (customElements.get('bean-fill-estimator-v3')) return;
  const engine = createFillEngine();
  class BeanFillEstimator extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      if (this.querySelector('[data-config-end]')) this.init();
      else {
        this.observer = new MutationObserver(()=>{
          if (this.querySelector('[data-config-end]')) { this.observer.disconnect(); this.init(); }
        });
        this.observer.observe(this,{childList:true,subtree:true});
      }
    }
    disconnectedCallback() { if (this.observer) this.observer.disconnect(); }
    $(name) { return this.querySelector(`[data-el="${name}"]`); }
    init() {
      if (this.ready) return;
      this.ready = true;
      this.state = {mode:'shape',shape:this.dataset.kind === 'beads' ? 'sphere' : 'box',lengthUnit:'in',volumeUnit:'ft3',dimensions:{},direct:null};
      this.catalog = {};
      this.querySelectorAll('[data-product-key]').forEach(el=>{
        const key = el.dataset.productKey;
        this.catalog[key] = {url:el.dataset.url,variants:[]};
        el.querySelectorAll('[data-variant-json]').forEach(node=>{
          try {
            const v = JSON.parse(node.dataset.variantJson);
            const size = engine.parsePack(v.options || [],key);
            if (!size) return;
            const stockLimited = node.dataset.managed === 'true' && node.dataset.policy === 'deny';
            const stock = stockLimited ? Math.max(0,Number(node.dataset.stock)) : 1000;
            const maxRule = node.dataset.max ? Number(node.dataset.max) : 1000;
            this.catalog[key].variants.push({id:v.id,title:v.public_title || v.title,size,price:v.price,available:v.available === true,
              max:Math.min(stock,maxRule,1000),min:Number(node.dataset.min) || 1,increment:Number(node.dataset.increment) || 1});
          } catch (_) { /* Unreadable variants cannot become cart recommendations. */ }
        });
      });
      const preferred = this.dataset.currentFill || this.dataset.defaultFill;
      if ([...this.$('fill').options].some(o=>o.value === preferred)) this.$('fill').value = preferred;
      this.$('shape').value = this.state.shape;
      this.renderDimensions();
      this.setPreset();
      this.addEventListener('input',event=>this.onInput(event));
      this.addEventListener('change',event=>this.onChange(event));
      this.$('reset-preset').addEventListener('click',()=>{ this.setPreset(); this.compute(); });
      this.$('add').addEventListener('click',()=>this.addToCart());
      this.$('interactive').disabled = false;
      this.$('loading').hidden = true;
      this.compute();
    }
    number(input) {
      if (!input || input.value.trim() === '' || input.validity.badInput) return null;
      const value = Number(input.value);
      return engine.positive(value) ? value : null;
    }
    tidy(value) { return value === null || !Number.isFinite(value) ? '' : String(Number(value.toPrecision(10))); }
    format(value) {
      if (value > 0 && value < 0.01) return '<0.01';
      return new Intl.NumberFormat(undefined,{maximumFractionDigits:2}).format(value);
    }
    money(cents) {
      try { return new Intl.NumberFormat(undefined,{style:'currency',currency:this.dataset.currency || 'USD'}).format(cents / 100); }
      catch (_) { return (cents / 100).toFixed(2) + ' ' + this.dataset.currency; }
    }
    renderDimensions() {
      const pane = this.$('dimensions');
      pane.replaceChildren();
      const saved = this.state.dimensions[this.state.shape] || {};
      engine.shapes[this.state.shape].fields.forEach(([key,label])=>{
        const wrap = document.createElement('div'); wrap.className = 'bf-field';
        const text = document.createElement('label');
        const input = document.createElement('input');
        input.id = this.id + '-dim-' + key;
        text.htmlFor = input.id; text.textContent = label;
        input.type = 'number'; input.min = '0'; input.step = 'any'; input.inputMode = 'decimal';
        input.dataset.dimension = key; input.placeholder = 'Enter measurement';
        input.setAttribute('aria-describedby',this.id + '-measure-help');
        input.value = saved[key] ? this.tidy(saved[key] / engine.lengthUnits[this.state.lengthUnit]) : '';
        wrap.append(text,input); pane.append(wrap);
      });
      this.$('shape-note').textContent = this.state.shape === 'sphere'
        ? 'Diameter means the full width across a sphere, not its radius. For a flattened round cushion, use the cylinder and measure its height.'
        : this.state.shape === 'tri_prism' ? 'Measure the triangular end: base and perpendicular height, then the length of the wedge.'
        : 'Measure the intended filled size, including thickness. Do not use the dimensions of a flattened empty cover.';
    }
    setPreset() {
      const pct = engine.preset(this.$('fill').value,this.$('use').value);
      this.$('percent').value = pct;
      this.$('range').value = pct;
      this.guidance();
    }
    guidance() {
      const fill = this.$('fill').value, use = this.$('use').value;
      const soft = engine.fills[fill].soft;
      let text;
      if (use === 'beanbag') text = 'Start with 40% of the measured shape volume. For the sphere option, that means 40% of a full sphere. Leave room for the beads to move; adjust to suit the cover and feel.';
      else if (use === 'seating') text = soft
        ? 'These loose fills compress under body weight. Start at 200% (twice the measured volume); more may be needed. Kapok and hemp fiber are poor choices for firm seating. Contact us if you need dependable support.'
        : 'Start at 100% for seating and ottomans. Buckwheat is best suited to smaller cushions because large quantities become heavy.';
      else if (use === 'body' || use === 'head') text = fill === 'buckwheat'
        ? (use === 'head' ? 'Start at 80%' : 'Start at 85%') + ' to leave room for the hulls to move and mold. Adjust for your preferred loft.'
        : (fill === 'latex' || fill === 'foam')
          ? 'Our shredded latex and foam are loose pieces, not solid foam cores. Start at 200% for support; more may be needed. Reduce the allowance for a softer, lower-loft pillow.'
          : 'Start at 100% for a pillow. Kapok and hemp fiber compress with use; increase the allowance for firmer support and adjust the fill gradually.';
      else if (use === 'decor') text = 'Start at 100% for decorative use. Less may be enough for a softer pillow; add more for a fuller look.';
      else text = 'Start at 100% as a volume estimate only. For a project that must support weight, select a supportive intended use or contact us.';
      if (soft) text += ' The density conversion stays the same; this allowance accounts for compression.';
      this.$('use-help').textContent = text;
      this.$('percent-value').textContent = this.$('percent').value || '—';
      this.$('job-help').textContent = this.$('job').value === 'full'
        ? 'An empty cover or complete replacement needs 100% of the full-fill estimate after the intended-use adjustment.'
        : this.$('job').value === 'refluff'
          ? 'A substantial refresh uses approximately 50% of the full-fill estimate. This is the amount to buy, not a change to the shape volume.'
          : 'A light top-up uses approximately 25–30% of the full-fill estimate. Package suggestions cover the upper end (30%). Existing fill condition varies.';
    }
    onInput(event) {
      const el = event.target;
      if (el.dataset.dimension) {
        const value = this.number(el);
        this.state.dimensions[this.state.shape] ||= {};
        this.state.dimensions[this.state.shape][el.dataset.dimension] = value === null ? null : value * engine.lengthUnits[this.state.lengthUnit];
      } else if (el === this.$('volume')) {
        const value = this.number(el);
        this.state.direct = value === null ? null : value * engine.volumeUnits[this.state.volumeUnit];
      } else if (el === this.$('range')) this.$('percent').value = el.value;
      else if (el === this.$('percent')) {
        const v = Number(el.value);
        if (v >= 10 && v <= 300) this.$('range').value = v;
      } else return;
      this.guidance(); this.compute();
    }
    onChange(event) {
      const el = event.target;
      if (el === this.$('fill') || el === this.$('use')) this.setPreset();
      else if (el === this.$('mode')) {
        this.state.mode = el.value;
        this.$('shape-pane').hidden = el.value !== 'shape';
        this.$('volume-pane').hidden = el.value !== 'volume';
      } else if (el === this.$('shape')) {
        this.state.shape = el.value; this.renderDimensions();
      } else if (el === this.$('length-unit')) {
        this.state.lengthUnit = el.value; this.renderDimensions();
      } else if (el === this.$('volume-unit')) {
        this.state.volumeUnit = el.value;
        this.$('volume').value = this.tidy(this.state.direct === null ? null : this.state.direct / engine.volumeUnits[this.state.volumeUnit]);
      }
      this.guidance(); this.compute();
    }
    compute() {
      if (this.busy) return;
      this.plan = null;
      this.$('add').hidden = true;
      this.$('purchase').hidden = true;
      this.$('warnings').replaceChildren();
      this.$('cart-status').textContent = '';
      const volume = this.state.mode === 'shape' ? engine.shapeVolume(this.state.shape,this.state.dimensions[this.state.shape] || {}) : this.state.direct;
      const percent = this.number(this.$('percent'));
      const fill = this.$('fill').value;
      const result = engine.estimate(volume,fill,percent,this.$('job').value);
      this.$('percent').setAttribute('aria-invalid',String(percent === null || percent < 10 || percent > 300));
      this.$('dimensions').querySelectorAll('input').forEach(input=>input.setAttribute('aria-invalid',String(input.value !== '' && this.number(input) === null)));
      this.$('volume').setAttribute('aria-invalid',String(this.$('volume').value !== '' && this.number(this.$('volume')) === null));
      this.$('empty').hidden = !!result;
      this.$('results').hidden = !result;
      if (!result) {
        this.$('empty').textContent = percent === null || percent < 10 || percent > 300 ? 'Enter a fill allowance from 10% to 300%.' : 'Enter a positive value for every measurement to see an estimate.';
        return;
      }
      this.$('raw-volume').textContent = this.format(result.volume) + ' ft³';
      this.$('full-volume').textContent = this.format(result.fullVolume) + ' ft³ of loose fill (' + percent + '%)';
      this.$('full-weight').textContent = this.format(result.fullWeight) + ' lb';
      this.$('quantity').textContent = (result.low === result.high ? this.format(result.high) : this.format(result.low) + '–' + this.format(result.high)) + ' ' + result.unit;
      this.$('density-note').textContent = fill === 'beads' ? 'Beads are sold by volume. Weight is estimated at 0.49 lb per ft³.' : 'Weight = adjusted loose-fill volume ÷ ' + engine.fills[fill].ft3PerLb + ' ft³ per lb. The support allowance is applied once.';
      const heavy = Number(this.dataset.heavy) || 50;
      const largeVolume = Number(this.dataset.largeVolume) || 30;
      const largeWeight = Number(this.dataset.largeWeight) || 80;
      const normal = Math.max(0,Number(this.dataset['normal' + fill.split('_').map(s=>s[0].toUpperCase() + s.slice(1)).join('')]) || 0);
      let contact = false;
      const warn = message=>{const p=document.createElement('p');p.textContent=message;this.$('warnings').append(p);};
      if (result.fullWeight > heavy) {
        warn('Heavy project: the full-fill estimate is about ' + this.format(result.fullWeight) + ' lb. Consider a lighter fill and contact us before ordering. A top-up amount may weigh less than the full project.'); contact = true;
      }
      if (result.orderVolume > largeVolume || result.orderWeight > largeWeight) {
        warn('This is an unusually large fill requirement. Please email us your project dimensions, fill choice and intended use before purchasing.'); contact = true;
      }
      if (normal > 0 && result.high > normal) {
        warn('This exceeds the regular purchase guidance of ' + this.format(normal) + ' ' + result.unit + ' for this fill. Contact us to confirm the amount and discuss larger orders.'); contact = true;
      }
      if (engine.fills[fill].soft && this.$('use').value === 'seating') warn('Loose soft fill can flatten significantly under a seated person. A larger amount does not guarantee the support of a solid cushion.');
      if ((fill === 'latex' || fill === 'foam') && ['seating','body','head'].includes(this.$('use').value) && percent < 200) warn('You have reduced the support allowance below our 200% starting guidance. Expect less support and adjust gradually.');
      this.$('warnings').hidden = !this.$('warnings').children.length;
      this.$('contact').hidden = !contact;
      const catalog = this.catalog[fill];
      const link = this.$('product-link');
      link.hidden = !catalog?.url;
      if (catalog?.url) link.href = catalog.url;
      this.$('purchase').hidden = false;
      this.$('packages').replaceChildren();
      this.$('purchase-total').textContent = '';
      if (contact) {
        this.$('purchase-note').textContent = 'Please confirm this estimate with us before buying. Automatic package recommendations are paused for this amount.';
        return;
      }
      this.plan = engine.packages(result.high,catalog?.variants || []);
      if (!this.plan) {
        this.$('purchase-note').textContent = 'We cannot match this estimate to available regular packages. View the product or contact us for help. No quantity has been added to your cart.';
        return;
      }
      const packageWeight = fill === 'beads' ? this.plan.total * 0.49 : this.plan.total;
      const packageVolume = fill === 'beads' ? this.plan.total : this.plan.total * engine.fills[fill].ft3PerLb;
      if (packageWeight > heavy || packageWeight > largeWeight || packageVolume > largeVolume || (normal > 0 && this.plan.total > normal)) {
        this.plan = null;
        this.$('purchase-note').textContent = 'The available packages would exceed our purchase review limits. Contact us to confirm a suitable order.';
        this.$('contact').hidden = false;
        return;
      }
      this.plan.items.forEach(item=>{
        const li = document.createElement('li');
        li.textContent = item.quantity + ' × ' + item.title + ' — ' + this.money(item.quantity * item.price);
        this.$('packages').append(li);
      });
      this.$('purchase-total').textContent = 'Package total: ' + this.format(this.plan.total) + ' ' + result.unit + ' · ' + this.money(this.plan.cost);
      this.$('purchase-note').textContent = 'Rounded up to available package sizes. We minimize excess fill first, then compare item prices for that amount. Shipping and discounts are calculated separately. Add gradually; you may not need every bit.';
      this.$('add').hidden = this.dataset.cartEnabled !== 'true';
      this.$('add').disabled = false;
    }
    async addToCart() {
      if (this.busy || !this.plan || this.$('add').hidden) return;
      const items = this.plan.items.map(item=>({id:item.id,quantity:item.quantity}));
      const root = window.Shopify?.routes?.root || '/';
      this.busy = true;
      this.$('interactive').disabled = true;
      this.$('add').disabled = true;
      this.$('cart-status').textContent = 'Adding the listed packages…';
      try {
        const response = await fetch(root + 'cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items})});
        const data = await response.json();
        if (!response.ok || data.status) throw new Error(typeof data.description === 'string' ? data.description : 'Shopify could not add this quantity.');
        this.$('cart-status').textContent = 'Added. Opening your cart…';
        window.location.assign(root + 'cart');
      } catch (error) {
        this.$('cart-status').textContent = (error.message || 'The request could not be completed.') + ' Check your cart before trying again; some items may have been added.';
        const a = document.createElement('a'); a.href = root + 'cart'; a.textContent = ' View cart';
        this.$('cart-status').append(a);
        // Keep retry disabled after an uncertain response to prevent accidental duplicate additions.
        this.plan = null;
        this.$('interactive').disabled = false;
        this.busy = false;
      }
    }
  }
  customElements.define('bean-fill-estimator-v3',BeanFillEstimator);
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["beanfill-calculator"] && !Shopify.designMode) return;
  try {
    
function createFillEngine() {
  'use strict';
  const fills = {
    beads: {name:'Bean bag beads', ft3PerLb:1 / 0.49, unit:'ft³', normal:10, soft:false},
    buckwheat: {name:'Buckwheat hulls', ft3PerLb:0.09, unit:'lb', normal:20, soft:false},
    kapok: {name:'Kapok fiber', ft3PerLb:0.45, unit:'lb', normal:20, soft:true},
    hemp_fiber: {name:'Hemp fiber', ft3PerLb:0.45, unit:'lb', normal:25, soft:true},
    latex: {name:'Shredded latex', ft3PerLb:0.29, unit:'lb', normal:20, soft:true},
    foam: {name:'Shredded foam', ft3PerLb:0.60, unit:'lb', normal:20, soft:true}
  };
  // Retained for future use only. Millet is unavailable and is not selectable.
  const unavailableDensities = {millet:0.14};
  const lengthUnits = {in:1 / 12, ft:1, cm:1 / 30.48, m:1 / 0.3048};
  const volumeUnits = {ft3:1, l:1 / 28.316846592, m3:1 / 0.028316846592, gal:1 / 7.48051948051948};
  const shapes = {
    sphere: {name:'Sphere / round bean bag', fields:[['d','Diameter']], volume:v=>Math.PI * v.d ** 3 / 6},
    box: {name:'Rectangular cushion / box', fields:[['l','Length'],['w','Width'],['h','Thickness / height']], volume:v=>v.l * v.w * v.h},
    cylinder: {name:'Round cushion / cylinder', fields:[['d','Diameter'],['h','Thickness / height']], volume:v=>Math.PI * v.d ** 2 * v.h / 4},
    cube: {name:'Cube', fields:[['a','Side length']], volume:v=>v.a ** 3},
    tri_prism: {name:'Wedge / triangular prism', fields:[['b','Triangle base'],['h','Triangle height'],['l','Length']], volume:v=>v.b * v.h * v.l / 2}
  };
  const positive = n => typeof n === 'number' && Number.isFinite(n) && n > 0;
  function shapeVolume(shape, values) {
    const config = shapes[shape];
    if (!config || !config.fields.every(([key])=>positive(values[key]))) return null;
    const volume = config.volume(values);
    return positive(volume) ? volume : null;
  }
  function preset(fill, use) {
    if (!fills[fill]) return null;
    if (use === 'beanbag') return 40;
    if (use === 'seating') return fills[fill].soft ? 200 : 100;
    if (use === 'body' || use === 'head') {
      if (fill === 'buckwheat') return use === 'head' ? 80 : 85;
      if (fill === 'latex' || fill === 'foam') return 200;
    }
    return 100;
  }
  function estimate(volume, fill, percent, job) {
    const material = fills[fill];
    if (!material || !positive(volume) || !Number.isFinite(percent) || percent < 10 || percent > 300 || !['full','refluff','topup'].includes(job)) return null;
    const fullVolume = volume * percent / 100;
    const ratios = job === 'topup' ? [0.25,0.30] : job === 'refluff' ? [0.5,0.5] : [1,1];
    const fullWeight = fullVolume / material.ft3PerLb;
    const fullQuantity = fill === 'beads' ? fullVolume : fullWeight;
    const result = {volume, fullVolume, fullWeight, low:fullQuantity * ratios[0], high:fullQuantity * ratios[1], orderVolume:fullVolume * ratios[1], orderWeight:fullWeight * ratios[1], unit:material.unit};
    return Object.values(result).filter(v=>typeof v === 'number').every(Number.isFinite) ? result : null;
  }
  function parsePack(options, fill) {
    const re = fill === 'beads' ? /^(\d+(?:\.\d+)?)\s*(?:cubic\s*(?:ft|feet)|cu\.?\s*ft\.?|ft³|ft3)\.?$/i : /^(\d+(?:\.\d+)?)\s*(?:lb|lbs|pound|pounds)\.?$/i;
    const matches = options.map(x=>String(x).trim().match(re)).filter(Boolean);
    if (matches.length !== 1) return null;
    const size = Number(matches[0][1]);
    // Retail sizes from the supplied product export; never infer size from shipping weight or SKU digits.
    const allowed = fill === 'beads' ? [2,4,8,10] : fill === 'hemp_fiber' ? [1,5,10,25] : [1,2.5,5,10,20];
    return allowed.includes(size) ? size : null;
  }
  // Bounded, half-unit dynamic programming: least excess first, then item price, then package count.
  // All amounts use unrounded calculations. Stock and quantity rules constrain eligible combinations.
  function packages(need, variants) {
    if (!positive(need) || need > 500) return null;
    const eligible = variants.filter(v=>positive(v.size) && Number.isFinite(v.price) && v.price >= 0 && v.available && v.max >= v.min && v.min >= 1 && v.increment >= 1);
    if (!eligible.length) return null;
    const target = Math.ceil(need * 2 - 1e-9);
    const ceiling = Math.min(4000,target + Math.max(...eligible.map(v=>Math.round(v.size * 2) * (v.min + v.increment - 1))) - 1);
    let dp = Array(ceiling + 1).fill(null);
    dp[0] = {cost:0,count:0,items:[]};
    for (const variant of eligible) {
      const next = dp.slice();
      const units = Math.round(variant.size * 2);
      const max = Math.min(variant.max,Math.floor(ceiling / units));
      for (let sum=0;sum<dp.length;sum++) {
        if (!dp[sum]) continue;
        for (let q=variant.min;q<=max;q+=variant.increment) {
          const total = sum + units * q;
          if (total > ceiling) break;
          const candidate = {cost:dp[sum].cost + q * variant.price,count:dp[sum].count + q,items:[...dp[sum].items,{...variant,quantity:q}]};
          const old = next[total];
          if (!old || candidate.cost < old.cost || (candidate.cost === old.cost && candidate.count < old.count)) next[total] = candidate;
        }
      }
      dp = next;
    }
    for (let sum=target;sum<dp.length;sum++) if (dp[sum]) return {...dp[sum],total:sum / 2};
    return null;
  }
  return {fills,unavailableDensities,lengthUnits,volumeUnits,shapes,positive,shapeVolume,preset,estimate,parsePack,packages};
}

(() => {
  'use strict';
  if (customElements.get('bean-fill-estimator-v3')) return;
  const engine = createFillEngine();
  class BeanFillEstimator extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      if (this.querySelector('[data-config-end]')) this.init();
      else {
        this.observer = new MutationObserver(()=>{
          if (this.querySelector('[data-config-end]')) { this.observer.disconnect(); this.init(); }
        });
        this.observer.observe(this,{childList:true,subtree:true});
      }
    }
    disconnectedCallback() { if (this.observer) this.observer.disconnect(); }
    $(name) { return this.querySelector(`[data-el="${name}"]`); }
    init() {
      if (this.ready) return;
      this.ready = true;
      this.state = {mode:'shape',shape:this.dataset.kind === 'beads' ? 'sphere' : 'box',lengthUnit:'in',volumeUnit:'ft3',dimensions:{},direct:null};
      this.catalog = {};
      this.querySelectorAll('[data-product-key]').forEach(el=>{
        const key = el.dataset.productKey;
        this.catalog[key] = {url:el.dataset.url,variants:[]};
        el.querySelectorAll('[data-variant-json]').forEach(node=>{
          try {
            const v = JSON.parse(node.dataset.variantJson);
            const size = engine.parsePack(v.options || [],key);
            if (!size) return;
            const stockLimited = node.dataset.managed === 'true' && node.dataset.policy === 'deny';
            const stock = stockLimited ? Math.max(0,Number(node.dataset.stock)) : 1000;
            const maxRule = node.dataset.max ? Number(node.dataset.max) : 1000;
            this.catalog[key].variants.push({id:v.id,title:v.public_title || v.title,size,price:v.price,available:v.available === true,
              max:Math.min(stock,maxRule,1000),min:Number(node.dataset.min) || 1,increment:Number(node.dataset.increment) || 1});
          } catch (_) { /* Unreadable variants cannot become cart recommendations. */ }
        });
      });
      const preferred = this.dataset.currentFill || this.dataset.defaultFill;
      if ([...this.$('fill').options].some(o=>o.value === preferred)) this.$('fill').value = preferred;
      this.$('shape').value = this.state.shape;
      this.renderDimensions();
      this.setPreset();
      this.addEventListener('input',event=>this.onInput(event));
      this.addEventListener('change',event=>this.onChange(event));
      this.$('reset-preset').addEventListener('click',()=>{ this.setPreset(); this.compute(); });
      this.$('add').addEventListener('click',()=>this.addToCart());
      this.$('interactive').disabled = false;
      this.$('loading').hidden = true;
      this.compute();
    }
    number(input) {
      if (!input || input.value.trim() === '' || input.validity.badInput) return null;
      const value = Number(input.value);
      return engine.positive(value) ? value : null;
    }
    tidy(value) { return value === null || !Number.isFinite(value) ? '' : String(Number(value.toPrecision(10))); }
    format(value) {
      if (value > 0 && value < 0.01) return '<0.01';
      return new Intl.NumberFormat(undefined,{maximumFractionDigits:2}).format(value);
    }
    money(cents) {
      try { return new Intl.NumberFormat(undefined,{style:'currency',currency:this.dataset.currency || 'USD'}).format(cents / 100); }
      catch (_) { return (cents / 100).toFixed(2) + ' ' + this.dataset.currency; }
    }
    renderDimensions() {
      const pane = this.$('dimensions');
      pane.replaceChildren();
      const saved = this.state.dimensions[this.state.shape] || {};
      engine.shapes[this.state.shape].fields.forEach(([key,label])=>{
        const wrap = document.createElement('div'); wrap.className = 'bf-field';
        const text = document.createElement('label');
        const input = document.createElement('input');
        input.id = this.id + '-dim-' + key;
        text.htmlFor = input.id; text.textContent = label;
        input.type = 'number'; input.min = '0'; input.step = 'any'; input.inputMode = 'decimal';
        input.dataset.dimension = key; input.placeholder = 'Enter measurement';
        input.setAttribute('aria-describedby',this.id + '-measure-help');
        input.value = saved[key] ? this.tidy(saved[key] / engine.lengthUnits[this.state.lengthUnit]) : '';
        wrap.append(text,input); pane.append(wrap);
      });
      this.$('shape-note').textContent = this.state.shape === 'sphere'
        ? 'Diameter means the full width across a sphere, not its radius. For a flattened round cushion, use the cylinder and measure its height.'
        : this.state.shape === 'tri_prism' ? 'Measure the triangular end: base and perpendicular height, then the length of the wedge.'
        : 'Measure the intended filled size, including thickness. Do not use the dimensions of a flattened empty cover.';
    }
    setPreset() {
      const pct = engine.preset(this.$('fill').value,this.$('use').value);
      this.$('percent').value = pct;
      this.$('range').value = pct;
      this.guidance();
    }
    guidance() {
      const fill = this.$('fill').value, use = this.$('use').value;
      const soft = engine.fills[fill].soft;
      let text;
      if (use === 'beanbag') text = 'Start with 40% of the measured shape volume. For the sphere option, that means 40% of a full sphere. Leave room for the beads to move; adjust to suit the cover and feel.';
      else if (use === 'seating') text = soft
        ? 'These loose fills compress under body weight. Start at 200% (twice the measured volume); more may be needed. Kapok and hemp fiber are poor choices for firm seating. Contact us if you need dependable support.'
        : 'Start at 100% for seating and ottomans. Buckwheat is best suited to smaller cushions because large quantities become heavy.';
      else if (use === 'body' || use === 'head') text = fill === 'buckwheat'
        ? (use === 'head' ? 'Start at 80%' : 'Start at 85%') + ' to leave room for the hulls to move and mold. Adjust for your preferred loft.'
        : (fill === 'latex' || fill === 'foam')
          ? 'Our shredded latex and foam are loose pieces, not solid foam cores. Start at 200% for support; more may be needed. Reduce the allowance for a softer, lower-loft pillow.'
          : 'Start at 100% for a pillow. Kapok and hemp fiber compress with use; increase the allowance for firmer support and adjust the fill gradually.';
      else if (use === 'decor') text = 'Start at 100% for decorative use. Less may be enough for a softer pillow; add more for a fuller look.';
      else text = 'Start at 100% as a volume estimate only. For a project that must support weight, select a supportive intended use or contact us.';
      if (soft) text += ' The density conversion stays the same; this allowance accounts for compression.';
      this.$('use-help').textContent = text;
      this.$('percent-value').textContent = this.$('percent').value || '—';
      this.$('job-help').textContent = this.$('job').value === 'full'
        ? 'An empty cover or complete replacement needs 100% of the full-fill estimate after the intended-use adjustment.'
        : this.$('job').value === 'refluff'
          ? 'A substantial refresh uses approximately 50% of the full-fill estimate. This is the amount to buy, not a change to the shape volume.'
          : 'A light top-up uses approximately 25–30% of the full-fill estimate. Package suggestions cover the upper end (30%). Existing fill condition varies.';
    }
    onInput(event) {
      const el = event.target;
      if (el.dataset.dimension) {
        const value = this.number(el);
        this.state.dimensions[this.state.shape] ||= {};
        this.state.dimensions[this.state.shape][el.dataset.dimension] = value === null ? null : value * engine.lengthUnits[this.state.lengthUnit];
      } else if (el === this.$('volume')) {
        const value = this.number(el);
        this.state.direct = value === null ? null : value * engine.volumeUnits[this.state.volumeUnit];
      } else if (el === this.$('range')) this.$('percent').value = el.value;
      else if (el === this.$('percent')) {
        const v = Number(el.value);
        if (v >= 10 && v <= 300) this.$('range').value = v;
      } else return;
      this.guidance(); this.compute();
    }
    onChange(event) {
      const el = event.target;
      if (el === this.$('fill') || el === this.$('use')) this.setPreset();
      else if (el === this.$('mode')) {
        this.state.mode = el.value;
        this.$('shape-pane').hidden = el.value !== 'shape';
        this.$('volume-pane').hidden = el.value !== 'volume';
      } else if (el === this.$('shape')) {
        this.state.shape = el.value; this.renderDimensions();
      } else if (el === this.$('length-unit')) {
        this.state.lengthUnit = el.value; this.renderDimensions();
      } else if (el === this.$('volume-unit')) {
        this.state.volumeUnit = el.value;
        this.$('volume').value = this.tidy(this.state.direct === null ? null : this.state.direct / engine.volumeUnits[this.state.volumeUnit]);
      }
      this.guidance(); this.compute();
    }
    compute() {
      if (this.busy) return;
      this.plan = null;
      this.$('add').hidden = true;
      this.$('purchase').hidden = true;
      this.$('warnings').replaceChildren();
      this.$('cart-status').textContent = '';
      const volume = this.state.mode === 'shape' ? engine.shapeVolume(this.state.shape,this.state.dimensions[this.state.shape] || {}) : this.state.direct;
      const percent = this.number(this.$('percent'));
      const fill = this.$('fill').value;
      const result = engine.estimate(volume,fill,percent,this.$('job').value);
      this.$('percent').setAttribute('aria-invalid',String(percent === null || percent < 10 || percent > 300));
      this.$('dimensions').querySelectorAll('input').forEach(input=>input.setAttribute('aria-invalid',String(input.value !== '' && this.number(input) === null)));
      this.$('volume').setAttribute('aria-invalid',String(this.$('volume').value !== '' && this.number(this.$('volume')) === null));
      this.$('empty').hidden = !!result;
      this.$('results').hidden = !result;
      if (!result) {
        this.$('empty').textContent = percent === null || percent < 10 || percent > 300 ? 'Enter a fill allowance from 10% to 300%.' : 'Enter a positive value for every measurement to see an estimate.';
        return;
      }
      this.$('raw-volume').textContent = this.format(result.volume) + ' ft³';
      this.$('full-volume').textContent = this.format(result.fullVolume) + ' ft³ of loose fill (' + percent + '%)';
      this.$('full-weight').textContent = this.format(result.fullWeight) + ' lb';
      this.$('quantity').textContent = (result.low === result.high ? this.format(result.high) : this.format(result.low) + '–' + this.format(result.high)) + ' ' + result.unit;
      this.$('density-note').textContent = fill === 'beads' ? 'Beads are sold by volume. Weight is estimated at 0.49 lb per ft³.' : 'Weight = adjusted loose-fill volume ÷ ' + engine.fills[fill].ft3PerLb + ' ft³ per lb. The support allowance is applied once.';
      const heavy = Number(this.dataset.heavy) || 50;
      const largeVolume = Number(this.dataset.largeVolume) || 30;
      const largeWeight = Number(this.dataset.largeWeight) || 80;
      const normal = Math.max(0,Number(this.dataset['normal' + fill.split('_').map(s=>s[0].toUpperCase() + s.slice(1)).join('')]) || 0);
      let contact = false;
      const warn = message=>{const p=document.createElement('p');p.textContent=message;this.$('warnings').append(p);};
      if (result.fullWeight > heavy) {
        warn('Heavy project: the full-fill estimate is about ' + this.format(result.fullWeight) + ' lb. Consider a lighter fill and contact us before ordering. A top-up amount may weigh less than the full project.'); contact = true;
      }
      if (result.orderVolume > largeVolume || result.orderWeight > largeWeight) {
        warn('This is an unusually large fill requirement. Please email us your project dimensions, fill choice and intended use before purchasing.'); contact = true;
      }
      if (normal > 0 && result.high > normal) {
        warn('This exceeds the regular purchase guidance of ' + this.format(normal) + ' ' + result.unit + ' for this fill. Contact us to confirm the amount and discuss larger orders.'); contact = true;
      }
      if (engine.fills[fill].soft && this.$('use').value === 'seating') warn('Loose soft fill can flatten significantly under a seated person. A larger amount does not guarantee the support of a solid cushion.');
      if ((fill === 'latex' || fill === 'foam') && ['seating','body','head'].includes(this.$('use').value) && percent < 200) warn('You have reduced the support allowance below our 200% starting guidance. Expect less support and adjust gradually.');
      this.$('warnings').hidden = !this.$('warnings').children.length;
      this.$('contact').hidden = !contact;
      const catalog = this.catalog[fill];
      const link = this.$('product-link');
      link.hidden = !catalog?.url;
      if (catalog?.url) link.href = catalog.url;
      this.$('purchase').hidden = false;
      this.$('packages').replaceChildren();
      this.$('purchase-total').textContent = '';
      if (contact) {
        this.$('purchase-note').textContent = 'Please confirm this estimate with us before buying. Automatic package recommendations are paused for this amount.';
        return;
      }
      this.plan = engine.packages(result.high,catalog?.variants || []);
      if (!this.plan) {
        this.$('purchase-note').textContent = 'We cannot match this estimate to available regular packages. View the product or contact us for help. No quantity has been added to your cart.';
        return;
      }
      const packageWeight = fill === 'beads' ? this.plan.total * 0.49 : this.plan.total;
      const packageVolume = fill === 'beads' ? this.plan.total : this.plan.total * engine.fills[fill].ft3PerLb;
      if (packageWeight > heavy || packageWeight > largeWeight || packageVolume > largeVolume || (normal > 0 && this.plan.total > normal)) {
        this.plan = null;
        this.$('purchase-note').textContent = 'The available packages would exceed our purchase review limits. Contact us to confirm a suitable order.';
        this.$('contact').hidden = false;
        return;
      }
      this.plan.items.forEach(item=>{
        const li = document.createElement('li');
        li.textContent = item.quantity + ' × ' + item.title + ' — ' + this.money(item.quantity * item.price);
        this.$('packages').append(li);
      });
      this.$('purchase-total').textContent = 'Package total: ' + this.format(this.plan.total) + ' ' + result.unit + ' · ' + this.money(this.plan.cost);
      this.$('purchase-note').textContent = 'Rounded up to available package sizes. We minimize excess fill first, then compare item prices for that amount. Shipping and discounts are calculated separately. Add gradually; you may not need every bit.';
      this.$('add').hidden = this.dataset.cartEnabled !== 'true';
      this.$('add').disabled = false;
    }
    async addToCart() {
      if (this.busy || !this.plan || this.$('add').hidden) return;
      const items = this.plan.items.map(item=>({id:item.id,quantity:item.quantity}));
      const root = window.Shopify?.routes?.root || '/';
      this.busy = true;
      this.$('interactive').disabled = true;
      this.$('add').disabled = true;
      this.$('cart-status').textContent = 'Adding the listed packages…';
      try {
        const response = await fetch(root + 'cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items})});
        const data = await response.json();
        if (!response.ok || data.status) throw new Error(typeof data.description === 'string' ? data.description : 'Shopify could not add this quantity.');
        this.$('cart-status').textContent = 'Added. Opening your cart…';
        window.location.assign(root + 'cart');
      } catch (error) {
        this.$('cart-status').textContent = (error.message || 'The request could not be completed.') + ' Check your cart before trying again; some items may have been added.';
        const a = document.createElement('a'); a.href = root + 'cart'; a.textContent = ' View cart';
        this.$('cart-status').append(a);
        // Keep retry disabled after an uncertain response to prevent accidental duplicate additions.
        this.plan = null;
        this.$('interactive').disabled = false;
        this.busy = false;
      }
    }
  }
  customElements.define('bean-fill-estimator-v3',BeanFillEstimator);
})();


  } catch(e) { console.error(e); }
})();
})();
